export function servicesReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_SERVICE":            
        case "UPDATE_SERVICE":
            let list = Object.assign({}, state);
            list[payload.service_id] = payload
            
            return list
        case "GET_SERVICES":
            return payload
        default:
            return state;
    }
    
}